require('expose-loader?InPlayOverviewComponents!../../../src/app/sportsbook_components/in_play_overview_components');
